
<v-flex>
    <div class="mb-8" style="overflow: hidden;">
        <v-progress-linear v-if="membershipOverlay" absolute indeterminate></v-progress-linear>

        <div class="float-left mr-10" style="min-width: 350px;">
            <card-unit :items="membershipDetailsItems">
                <template #title>
                    {{ t('user_label_membership_details') }}
                    <v-spacer></v-spacer>

                    <user-premium-modal :value="user" @cancel="onPremiumUpdated" @submit="onPremiumUpdated">
                        <template #default="{ on, attrs }">
                            <a
                                href="javascript:"
                                v-on="on"
                                v-bind="attrs"
                            ><v-icon left>mdi-pencil</v-icon> {{ t('general_action_edit') }}</a>
                        </template>
                    </user-premium-modal>
                </template>
            </card-unit>
        </div>

        <div class="float-left mr-10" v-if="membershipDatesItems.length > 0" style="min-width: 350px;">
            <card-unit :items="membershipDatesItems">
                <template #title>{{ t('user_label_membership_dates_and_tech') }}</template>
            </card-unit>
        </div>

        <div class="float-left mr-10" style="min-width: 350px; position: relative;">
            <user-bubble-allowance-card :user="user" :key="`bubble_${user.premiumStatus}`"></user-bubble-allowance-card>
        </div>
    </div>

    <template v-if="touchedWebhookLog.exists()">
        <v-app-bar
            color="transparent"
            height="84"
            elevation="0"
            class="px-0-nested mb-n6 mt-4"
        >
            <v-toolbar-title class="font-weight-bold">
                {{ t('webhook_log_label_id') }} #{{ touchedWebhookLog.id }}
                <v-chip small class="ml-2" :color="['BILLING_ISSUE', 'CANCELLATION', 'EXPIRATION'].includes(touchedWebhookLog.type) ? 'error' : 'primary'">
                    {{ touchedWebhookLog.type }}
                </v-chip>
            </v-toolbar-title>
            <v-btn
                @click="touchedWebhookLog.unset()"
                plain
                icon
                absolute
                right
                class="mr-n8"
            ><v-icon>mdi-close</v-icon></v-btn>
        </v-app-bar>

        <webhook-log-view :log="touchedWebhookLog"></webhook-log-view>
    </template>

    <template v-else>
        <card-collection
            :meta="meta"
            :busy="overlay"
            @updated="updated"
        >
            <template #filters>
                <v-toolbar elevation="0" color="transparent" height="56">
                    <v-text-field v-model="queries.search" @click:clear="clear" class="input-search md mr-2" clearable outlined dense hide-details prepend-inner-icon="mdi-magnify" :label="t('general_label_search')"></v-text-field>
                    <span class="sub-label px-5">{{ t('general_label_date_period') }}</span>
                    <date-picker-modal :value="queries.date_from" @updated="(v) => queries.date_from = v"><template #default="{ on, attrs }"><div v-on="on" v-bind="attrs"><v-text-field v-model="queries.date_from" class="xs input-color-inherit" outlined dense hide-details readonly :label="t('general_label_from')"></v-text-field></div></template></date-picker-modal>
                    <span class="sub-label px-2">-</span>
                    <date-picker-modal :value="queries.date_to" @updated="(v) => queries.date_to = v"><template #default="{ on, attrs }"><div v-on="on" v-bind="attrs"><v-text-field v-model="queries.date_to" class="xs input-color-inherit" outlined dense hide-details readonly :label="t('general_label_to')"></v-text-field></div></template></date-picker-modal>
                    <v-select v-model="queries.type" :items="[ { text: '-', value: '' } ].concat(webhookLogTypes())" class="md ml-5" outlined dense append-icon="mdi-chevron-down" hide-details :label="t('webhook_log_label_type')"></v-select>
                    <v-btn @click="search" class="sm mx-5" color="primary">{{ t('general_action_search') }}</v-btn>
                    <v-btn v-ripple="false" plain color="orange darken-4" @click="reset">{{ t('general_action_reset_filters') }}</v-btn>
                </v-toolbar>
            </template>

            <template #data>
                <thead>
                <tr>
                    <th class="touched"><sort-field v-model="queries.sort" field="id" @touched="onSort">{{ t('webhook_log_label_id') }}</sort-field></th>
                    <th>{{ t('webhook_log_label_rc_event_id') }}</th>
                    <th><sort-field v-model="queries.sort" field="type" @touched="onSort">{{ t('webhook_log_label_type') }}</sort-field></th>
                    <th><sort-field v-model="queries.sort" field="created_at" @touched="onSort">{{ t('webhook_log_label_created_at') }}</sort-field></th>
                    <th class="text-center">{{ t('general_label_action') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="collection.data.length === 0"><td class="text-center" colspan="7">{{ t('general_text_no_data') }}</td></tr>
                <template v-else v-for="log in collection.data">
                    <tr :key="log.id">
                        <td>{{ log.id }}</td>
                        <td><span style="font-size: 0.85em; color: gray;">{{ log.rcEventId }}</span></td>
                        <td style="font-weight: 600" :class="{'red--text text--darken-2': ['BILLING_ISSUE', 'CANCELLATION', 'EXPIRATION'].includes(log.type), 'green--text text--darken-2': ['INITIAL_PURCHASE', 'RENEWAL'].includes(log.type), 'orange--text text--darken-4': log.type === 'TRANSFER'}">{{ log.type }}</td>
                        <td>{{ log.createdAt ? log.createdAt.format('DD/MM/YYYY HH:mm') : '-' }}</td>
                        <td class="text-center">
                            <v-btn icon @click.prevent="touchWebhookLog(log)">
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                </template>
                </tbody>
            </template>
        </card-collection>
    </template>
</v-flex>
